export interface PostTheme {
  id: string;
  wp_post_url?: string | null;
  wp_sent_date?: string | null;
  content?: string | null;
  description?: string | null;
  status?: string | null;
}

export const canSendToWordPress = (post: PostTheme, wpConfigured: boolean = false, isSendingToWP: boolean = false) => {
  // Allow sending when WP is configured, not already sending, not already sent,
  // and there is content available (description or content field)
  const hasContent = Boolean((post.description && post.description.trim().length > 0) || (post.content && post.content.trim().length > 0));
  return wpConfigured && !isSendingToWP && !post.wp_post_url && hasContent;
};

/**
 * Ensures WordPress post URLs are in the proper public format
 * @param url - The WordPress post URL (could be internal or public)
 * @param websiteUrl - The base website URL
 * @returns The proper public WordPress post URL
 */
export function ensurePublicWordPressUrl(url: string | null | undefined, websiteUrl?: string): string | null {
  if (!url) return null;
  
  // If it's already a proper public URL (not containing ?p=), return as is
  if (!url.includes('?p=') && !url.includes('/wp-admin')) {
    return url;
  }
  
  // If we have a website URL, try to construct the proper public URL
  if (websiteUrl) {
    try {
      // Extract post ID from WordPress internal URL
      const postIdMatch = url.match(/[?&]p=(\d+)/);
      if (postIdMatch) {
        const postId = postIdMatch[1];
        // For now, return the website URL since we can't construct the slug without API call
        // This is a fallback for old URLs that might still be in the database
        console.log('WordPress URL conversion: Internal URL detected, using website URL as fallback', { 
          originalUrl: url, 
          postId, 
          fallbackUrl: websiteUrl 
        });
        return websiteUrl;
      }
    } catch (error) {
      console.warn('Error processing WordPress URL:', error);
    }
  }
  
  // If we can't convert it, return the original URL
  return url;
} 